import { gql } from "apollo-boost";

export const MUTATION_RESPONSE_FRAGMENT = gql`
fragment MutationResponse on Response {
	request_id
	status
	error
	message
}
`;